// API Configuration
export const API_CONFIG = {
  POKKETAPI: {
    BASE_URL: process.env.REACT_APP_POKKETAPI_URL || 'https://dev1.pokketcoach.com:1337',
    ENDPOINTS: {
      // Chat API endpoints
      SEND_MESSAGE: '/api/v1/chat/send-message',
      GET_SESSION_MESSAGES: '/api/v1/chat/get-messages-in-session',
      INITIATE_CHAT: '/api/v1/chat/initiate-chat',
      GET_SESSION: '/api/v1/chat/get-session',
      GET_SUGGESTION_CARDS: '/api/v1/chat/get-suggestion-cards',
      
      // User API endpoints
      GET_USER_DETAILS: '/api/v1/user/get-details',
      GET_ONBOARDING_STATUS: '/api/v1/user/get-onboarding-status',
      LIST_GAMES: '/api/v1/user/list-games',
      COMPLETE_ONBOARDING: '/api/v1/user/complete-onboarding',
      UPDATE_USER_DETAILS: '/api/v1/user/update-details',
      
      // Psychtest API endpoints
      GET_ALL_TESTS: '/api/v1/psychtest/get-all-tests',
      START_TEST: '/api/v1/psychtest/test/id={testId}/start',
      GET_NEXT_QUESTION: '/api/v1/psychtest/test/session/{sessionId}/next-question',
      SUBMIT_ANSWER: '/api/v1/psychtest/test/session/{sessionId}/submit-answer',
      GET_TEST_RESULTS: '/api/v1/psychtest/test/session/{sessionId}/results',
      GET_ALL_RESULTS: '/api/v1/psychtest/get-my-results',
      GET_TEST_REPORT: '/api/v1/psychtest/test/get-or-generate-report/{sessionId}',
      
      // Coach API endpoints
      GET_GOALS: '/api/v1/coach/get-goals',
      GET_TAKEAWAYS: '/api/v1/coach/get-takeaways',
      GET_LAST_CHAT_SUMMARY: '/api/v1/coach/get-last-chat-summary',
      
      // Billing API endpoints
      GET_BILLING_STATUS: '/api/v1/billing/billing-status',
      GET_MANAGE_ACCOUNT_URL: '/api/v1/billing/manage-account',
      GET_CHECKOUT_URL: '/api/v1/billing/checkout',
      
      // Bug report API endpoint
      SUBMIT_BUG_REPORT: '/api/v1/bugreport/submit'
    }
  },
  SUPABASE: {
    URL: process.env.REACT_APP_SUPABASE_URL,
    ANON_KEY: process.env.REACT_APP_SUPABASE_ANON_KEY
  }
};

// Debug environment variables
console.log('Environment Variables:', {
  POKKETAPI_URL: process.env.REACT_APP_POKKETAPI_URL,
  SUPABASE_URL: process.env.REACT_APP_SUPABASE_URL
});

/**
 * Helper function to get full API URL
 * @param {string} endpoint - The API endpoint path 
 * @returns {string} The complete API URL
 */
export const getApiUrl = (endpoint) => {
  // Get base URL, with fallback
  const baseUrl = process.env.REACT_APP_POKKETAPI_URL || API_CONFIG.POKKETAPI.BASE_URL;
  
  if (!baseUrl) {
    console.error('API base URL is not defined');
    return endpoint; // Return just the endpoint as fallback
  }
  
  // Clean up the URL by removing trailing slashes from base and adding slash before endpoint if needed
  const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  
  const fullUrl = `${cleanBaseUrl}${cleanEndpoint}`;
  console.log('Built API URL:', fullUrl);
  
  return fullUrl;
}; 